const addQueryParams = (params) => {
  const searchParams = new URLSearchParams(window.location.search);

  for (const param in params) {
    if (param) searchParams.set(param, params[param]);
  }
  const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
  history.pushState(null, "", newRelativePathQuery);
};

export default addQueryParams;
